import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CompleteWebhookFragment = { __typename?: 'Webhook', id?: string | null, active?: boolean | null, events?: Array<string | null> | null, name?: string | null, url?: string | null, insertedAt?: string | null, workspace?: { __typename?: 'Workspace', id: string, name: string, projectCount?: number | null, images?: { __typename?: 'Images', image64?: string | null } | null } | null };

export const CompleteWebhook = /*#__PURE__*/ gql`
    fragment CompleteWebhook on Webhook {
  id
  active
  events
  name
  url
  insertedAt
  workspace {
    id
    name
    images {
      image64
    }
    projectCount
  }
}
    ` as unknown as DocumentNode<CompleteWebhookFragment, unknown>;

        

        
export const useCompleteWebhookFragment = (
  input: string | Omit<UseFragmentOptions<CompleteWebhookFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Webhook' } };
    return input;
  })();

  return useFragment<CompleteWebhookFragment>({
    fragment: CompleteWebhook,
    fragmentName: 'CompleteWebhook',
    ...options,
  });
};
  
        